import { useState } from "react";

function VisitingCardSection() {
  const [isCardFlipped, setIsCardFlipped] = useState(false);

  return (
    <section className="section visiting-section">
      <div className="section-title">
        <p>Visiting Card</p>
        <h2>Keep Our Details Handy</h2>
      </div>
      <button
        type="button"
        className={`visiting-card ${isCardFlipped ? "flipped" : ""}`}
        onClick={() => setIsCardFlipped((prev) => !prev)}
        aria-pressed={isCardFlipped}
        aria-label="Flip visiting card to view back side"
      >
        <span className="card-face card-front">
          <img
            src={`${process.env.PUBLIC_URL}/visiting-front.png`}
            alt="GURU KRIPA visiting card front"
            loading="lazy"
          />
        </span>
        <span className="card-face card-back">
          <img
            src={`${process.env.PUBLIC_URL}/visiting-back.png`}
            alt="GURU KRIPA visiting card back"
            loading="lazy"
          />
        </span>
      </button>
      <div className="visiting-hint">
        <img src={`${process.env.PUBLIC_URL}/image.png`} alt="" aria-hidden="true" />
        <span>Tap to flip the card</span>
      </div>
    </section>
  );
}

export default VisitingCardSection;
